import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { listCheckoutSessions, generateInvoice, registerManualPayment } from "../../../../services/platform_admin_service";

const usePlatformBilling = () => {
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25, totalItems: 0, totalPages: 0 });
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSessions = useCallback(async (page = 1, pageSize = 25, currentFilters = {}) => {
        try {
            setLoading(true);
            setError(null);
            const result = await listCheckoutSessions({ page, pageSize, filters: currentFilters });
            setItems(result.items || []);
            setPagination(result.pagination || {});
        } catch (err) {
            console.error("[usePlatformBilling]", err);
            setError(err.message || "Erro ao carregar checkout sessions.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSessions(1, 25, filters);
    }, [fetchSessions, filters]);

    const goToPage = (page) => fetchSessions(page, pagination.pageSize, filters);
    const applyFilters = (newFilters) => setFilters(newFilters);

    const createInvoice = async (idTenant, planCode, paymentMethod) => {
        try {
            setLoading(true);
            setError(null);
            const result = await generateInvoice(idTenant, planCode, paymentMethod);
            await fetchSessions(1, pagination.pageSize || 25, filters);
            toast.success("Cobrança gerada com sucesso!");
            return result;
        } catch (err) {
            const msg = err.message || "Erro ao gerar cobrança.";
            setError(msg);
            toast.error(msg);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const addManualPayment = async (idTenant, paymentData) => {
        try {
            setLoading(true);
            setError(null);
            const result = await registerManualPayment(idTenant, paymentData);
            await fetchSessions(1, pagination.pageSize || 25, filters);
            toast.success("Pagamento registrado com sucesso!");
            return result;
        } catch (err) {
            const msg = err.message || "Erro ao registrar pagamento.";
            setError(msg);
            toast.error(msg);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        items,
        pagination,
        loading,
        error,
        goToPage,
        applyFilters,
        filters,
        createInvoice,
        addManualPayment,
    };
};

export default usePlatformBilling;
